import type {
  GetListResponseOfNoteSimpleResponse,
  GetNoteListRequest,
  NoteRequest,
} from 'src/api/ProactApiClient';
import {noteApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery, voidClientQuery} from '../clientQuery';

export interface DeleteNoteRequest {
  id: number;
  entityId: number;
}

export const noteApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getNoteList: builder.query<
      GetListResponseOfNoteSimpleResponse,
      GetNoteListRequest
    >({
      queryFn: clientQuery(params => noteApiClient.list(params)),
      providesTags: ['Notes'],
    }),
    createNote: builder.mutation<boolean, NoteRequest>({
      queryFn: clientQuery(request => noteApiClient.create(request)),
      invalidatesTags: ['Notes'],
    }),
    updateNote: builder.mutation<boolean, NoteRequest>({
      queryFn: clientQuery(request => noteApiClient.update(request)),
      invalidatesTags: ['Notes'],
    }),
    deleteNote: builder.mutation<void, DeleteNoteRequest>({
      queryFn: voidClientQuery(({id, entityId}) =>
        noteApiClient.delete(id, entityId)
      ),
      invalidatesTags: ['Notes'],
    }),
  }),
});

export const {
  useGetNoteListQuery,
  useCreateNoteMutation,
  useUpdateNoteMutation,
  useDeleteNoteMutation,
} = noteApi;
